import { render } from "./LockerInstructionsCoinlock_1.vue?vue&type=template&id=28946ceb"
import script from "./LockerInstructionsCoinlock_1.vue?vue&type=script&lang=js"
export * from "./LockerInstructionsCoinlock_1.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__